<div class="container h-100 pt-5">
    <div class="row h-100 justify-content-center align-items-center font-small">
        <div class="d-flex flex-column">
            <div class="p-0 p-sm-5 form-container d-flex flex-column rounded-top">
                <ng-container *ngIf="customizations$ | async as customizations">
                    <div class="d-flex justify-content-center">
                        <p-image src="{{ 'data:image/png;base64,' + customizations.logoData }}" alt="Logo" *ngIf="!!customizations.logoData"></p-image>
                        <p-image src="../../assets/image/sf-fitness-logo_login.png" alt="Logo" width="250" *ngIf="!customizations.logoData"></p-image>
                    </div>
                </ng-container>

                <div class="pt-5">
                    <form [formGroup]="signInForm" (keyup.enter)="submitLogin()" style="width: 350px">
                        <div *ngrxLet="signInError$; let signInError">
                            <div *ngIf="signInError?.message !== null" class="alert alert-danger" role="alert">
                                {{ signInError?.message }}
                            </div>
                        </div>
                        <div class="form-group w-100">
                            <div class="p-input-icon-left w-100">
                                <i class="pi pi-envelope"></i>
                                <input type="text" pInputText formControlName="email" class="w-100" required />
                            </div>
                            <div *ngIf="email?.invalid && (email?.dirty || email?.touched)" style="font-size: small" class="text-danger pt-1">
                                <div *ngIf="email?.errors?.['required']">{{ 'VALIDATION_EMAIL' | translate }}</div>
                                <div *ngIf="email?.errors?.['email']">{{ 'VALIDATION_EMAIL' | translate }}</div>
                            </div>
                        </div>
                        <div class="form-group w-100">
                            <div class="p-input-icon-left w-100">
                                <i class="pi pi-key"></i>
                                <input type="password" pInputText formControlName="password" class="w-100" required />
                            </div>
                        </div>
                        <div class="form-group d-flex justify-content-end">
                            <a routerLink="/auth/reset-password" class="link-primary">
                                <small class="form-text">{{ 'RESET_PASSWORD_PAGE_TITLE' | translate }}</small>
                            </a>
                        </div>
                        <div class="form-group w-100">
                            <button class="btn btn-primary btn-block" (click)="submitLogin()">
                                {{ 'LOGIN_PAGE_TITLE' | translate }}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            <div class="form-group d-flex w-100 p-2 sign-link">
                <a routerLink="/auth/sign-up">
                    <small class="form-text">{{ 'AUTHENTICATION.LOGIN.SIGN_UP_REQUEST' | translate }}</small>
                </a>
            </div>
            <div class="m-5 d-flex flex-fill justify-content-center" style="font-size: 0.75rem">
                Powered by <a href="https://www.skedflex.eu/" class="ml-1">SkedFlex Fitness</a>
            </div>
        </div>
    </div>
</div>
